import React from 'react';
import './style.css';

const ContainerPrimas = ({ primasData }) => {
  return (
    <div className="container_primas">
      {primasData.map(({ name, formula, style, value }, index) => (
        <p
          key={index}
          style={{
            fontWeight: index === primasData.length - 1 && 'bold',
          }}
          className="text"
        >
          <strong>{name}: </strong>
          {formula} = {value}€
        </p>
      ))}
    </div>
  );
};

export default ContainerPrimas;
